import MainSearchPageContent from '../components/Main/Main.js';

const MainSearchPage = () => {
  return <MainSearchPageContent />;
};

export default MainSearchPage;
